<div class="operation-type-filter">
  <nz-radio-group
    [ngModel]="operation"
    (ngModelChange)="changeOperation($event)"
  >
    <label
      nz-radio
      [nzValue]="saleOperation.value"
    >
      {{saleOperation.label}}
    </label>

    <div class="operation-type-filter__checkbox-group">
      <div
        class="checkbox-list__body--row"
        *ngFor="let option of options"
      >
        <label
          nz-checkbox
          [class.checked]="option.checked"
          [nzChecked]="option.checked"
          (nzCheckedChange)="selectStage(option, $event)"
        >
          {{option.label}}
        </label>
      </div>
    </div>

    <label
      nz-radio
      [nzValue]="rentOperation.value"
    >
      {{rentOperation.label}}
    </label>
  </nz-radio-group>
</div>
